import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  userDetail: {}
};

export default function userInfo(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取个人信息详细数据
    case ACTION_TYPES.GET_USER_INFO:
      result.userDetail = payload;
      break;
    default:
      result = state;
  }
  return result;
}
